<template>
    <div class="scrollable only-y">
        <div v-loading="loading" class="card-base card-shadow--medium demo-box bg-white animated fadeInUp" style="padding: 20px">
            <el-col :lg="24" :md="24" :sm="24" :xs="24">
                <el-table
                        :data="search !== '' ? filtered : sinavOgrenciList"
                        border
                        stripe
                        style="width: 100%">
                    <el-table-column
                            label="Sıra"
                            type="index"
                            width="50">
                    </el-table-column>
                    <el-table-column
                            prop="ogrNo"
                            label="Öğrenci No"
                            width="120">
                    </el-table-column>
                    <el-table-column
                            prop="soyadAd"
                            label="Soyisim İsim"
                            width="auto">
                    </el-table-column>
                    <el-table-column
                            prop="sinif"
                            label="Sınıf"
                            width="120">
                    </el-table-column>
                    <el-table-column
                            label="İşlem"
                            align="right"
                            width="150">
                        <template slot="header" slot-scope="scope">
                            <el-input placeholder="Öğrenci Arama" @input="displayData" v-on:clearable="clearInput" clearable size="mini" v-model="search"></el-input>
                        </template>
                        <template slot-scope="scope">
                            <el-tooltip content='Sınav Sonucunu Görüntüle'
                                        :open-delay="500"
                                        placement="left">
                                <el-button
                                        v-on:click="getSinavSonuc(scope.row)"
                                        type="text"
                                        class="buttonAktif"
                                        icon="mdi mdi-information mdi-24px">
                                </el-button>
                            </el-tooltip>
                        </template>
                    </el-table-column>
                </el-table>
            </el-col>
        </div>
    </div>
</template>

<script>
    import sinavService from "../../../WSProvider/SinavService";
    import notification from "../../../notification";
    import kullaniciService from "../../../WSProvider/KullaniciService";

    export default {
        name: "SinavOgrenciListesi",

        data(){
            return {
                gelenSinavId: this.$store.getters.getSinavId,
                sinavOgrenciList: [],
                secilenSinavVerisi: [],
                filtered: [],
                loading: true,
                search: '',
            }
        },
        mounted() {
            this.getSinavOgrenciList()
        },
        methods: {
            clearInput(){
                this.loading = true;
                this.sinavOgrenciList = [];
                this.getSinavOgrenciList()
            },
            displayData(val) {
                if (val !== '') {
                    this.filtered = this.sinavOgrenciList.filter(data => data.soyadAd.toLowerCase().includes(this.search.toLowerCase()) || data.ogrNo.includes(this.search));
                } else {
                    this.clearInput()
                }
            },
            getSinavOgrenciList() {
                sinavService.sinavOgrList(this.gelenSinavId).then((response) => {
                    if (response.status === 200) {
                        this.sinavOgrenciList = response.data;
                        this.loading = false;
                    } else {
                        notification.Status(response.status, this)
                    }
                });
            },
            getSinavSonuc(val) {
                kullaniciService.ogrenciSinavDetay(val.kullaniciId, val.sinavId).then((response) => {
                    if (response.status === 200) {
                        this.secilenSinavVerisi = response.data;
                        sonucCikti(this.secilenSinavVerisi)
                    } else {
                        notification.Status(response.status, this);
                    }
                });
            },
        }
    }

    function veriKontrol(gelenVeri) {
        console.log(gelenVeri)
        if (gelenVeri === '' || gelenVeri === ' ') {
            return '-'
        } else {
            return gelenVeri
        }
    }

    function sonucCikti(ogrenciSinavBilgileri) {
        const ciktiCSS = `

        @font-face {
            font-family: 'Kabrio Abarth';
            src: url('http://89.252.181.6/batikoleji/panel/fonts/KabrioAbarth-ExtraBold.woff2') format('woff2'),
            url('http://89.252.181.6/batikoleji/panel/fonts/KabrioAbarth-ExtraBold.woff') format('woff');
            font-weight: bold;
            font-style: normal;
            font-display: swap;
        }

        * {
            -webkit-print-color-adjust: exact !important;   /* Chrome, Safari, Edge */
            color-adjust: exact !important;                 /*Firefox*/
        }

        img {
            user-select: none;
            pointer-events: none;
        }

        body {
            overflow-x: hidden !important;
        }

        .logoAlani {
            border-radius: 50%;
            background: #ffffff;
            padding: 10px;
            aspect-ratio: 1/1;
            display: flex;
            align-items: center;
            justify-content: center;
        }

        .logoAlani img{
            width: 100%
        }


        .ustAlan {
            position: relative;
            background: #f2f2f2;
            border-radius: 92px 0 0 92px;
        }

        .ustAlan::before {
            content: "";
            position: absolute;
            right: calc(-100% + 1px);
            top: 0;
            height: 100%;
            width: 100%;
            background: #f2f2f2;

        }

        .sinavBasligi {
            font-size: 28px;
            font-weight: bold;
            color: #e6297c;
        }

        .bilgiIcerik,
        .bilgiBaslik {
            position: relative;
            padding: 0 0 0 15px;
            margin: 0;
            list-style: none;
        }

        .bilgiIcerik::before,
        .bilgiBaslik::before {
            content: "";
            position: absolute;
            left: 0;
            top: 0;
            height: 100%;
            width: 2px;
            background: #cbcbcb;
        }

        .bilgiBaslik li {
            display: block;
            font-weight: bold;
            position: relative;
        }

        .bilgiBaslik li::before {
            content: "";
            position: absolute;
            left: -17px;
            top: 50%;
            transform: translateY(-50%);
            width: 6px;
            height: 6px;
            background: #e6297c;
            border-radius: 50%;
        }

        .bilgiIcerik li {
            display: block;
            position: relative;
        }

        .bilgiIcerik li::before {
            content: "";
            position: absolute;
            left: -17px;
            top: 50%;
            transform: translateY(-50%);
            width: 6px;
            height: 6px;
            background: #28abe2;
            border-radius: 50%;
        }

        .kutuBaslik {
            background: #28abe2;
            border-radius: 5px 5px 0 0;
            border: 1px solid #cccccc;
            color: #ffffff;
            font-size: 20px;
            font-weight: bold;
            text-align: center;
            padding: 5px 0;
        }

        .kutuIcerik {
            background: #f2f2f2;
            border: 1px solid #cccccc;
            border-top: none;
            padding: 5px 0;
            font-size: 20px;
            letter-spacing: 1px;
            text-align: center;
        }

        .tabloBaslik {
            background: #e6297c;
            color: #ffffff;
            border-radius: 5px 5px 0 0;
            padding: 4px 0;
            font-size: 18px;
            font-weight: 400;
            text-align: center;
        }

        .tabloBaslik.sayilar {
            background: #28abe2;
        }


        .dersCol .border .ozelCol:nth-child(odd) .dersRow .col {
            padding: 5px 0;
            text-align: center;
            background: #ffffff;
        }

        .dersCol .border .ozelCol:nth-child(even) .dersRow .col {
            padding: 5px 0;
            text-align: center;
            background: #f9f9f9;
        }

        .dersRow .col::before {
            content: "";
            position: absolute;
        }

        .tabloVeri {
            position: relative;
        }

        .tabloVeri::before {
            content: "";
            position: absolute;
            right: 0;
            top: -5px;
            height: calc(100% + 10px);
            width: 1px;
            background: #cccccc;
        }

        .tabloVeri::after {
            content: "";
            position: absolute;
            left: 0;
            bottom: -5px;
            height: 1px;
            width: 100%;
            background: #cccccc;
        }

        .border .ozelCol:last-of-type .tabloVeri::after {
            display: none;
        }

        .dersRow .row .col:last-of-type .tabloVeri::before {
            display: none;
        }
        `;
        const ciktiCSSMobil = `

        @font-face {
            font-family: 'Kabrio Abarth';
            src: url('http://89.252.181.6/batikoleji/panel/fonts/KabrioAbarth-ExtraBold.woff2') format('woff2'),
            url('http://89.252.181.6/batikoleji/panel/fonts/KabrioAbarth-ExtraBold.woff') format('woff');
            font-weight: bold;
            font-style: normal;
            font-display: swap;
        }

        * {
            -webkit-print-color-adjust: exact !important; /* Chrome, Safari, Edge */
            color-adjust: exact !important; /*Firefox*/
        }

        img {
            user-select: none;
            pointer-events: none;
        }

        body {
            overflow-x: hidden !important;
        }

        .pembebg {
            background: #e6297c;
        }

        .sinavBasligi {
            font-size: 28px;
            font-weight: bold;
            color: #ffffff;
            text-align: center;
            line-height: 1;
            padding: 10px 0;
        }

        .bilgiIcerik,
        .bilgiBaslik {
            position: relative;
            padding: 0 0 0 15px;
            margin: 0;
            list-style: none;
        }

        .bilgiIcerik::before,
        .bilgiBaslik::before {
            content: "";
            position: absolute;
            left: 0;
            top: 0;
            height: 100%;
            width: 2px;
            background: #cbcbcb;
        }

        .bilgiBaslik li {
            display: block;
            font-weight: bold;
            position: relative;
            font-size: 14px;
        }

        .bilgiBaslik li::before {
            content: "";
            position: absolute;
            left: -17px;
            top: 50%;
            transform: translateY(-50%);
            width: 6px;
            height: 6px;
            background: #e6297c;
            border-radius: 50%;
        }

        .bilgiIcerik li {
            display: block;
            position: relative;
            font-size: 14px;
        }

        .bilgiIcerik li::before {
            content: "";
            position: absolute;
            left: -17px;
            top: 50%;
            transform: translateY(-50%);
            width: 6px;
            height: 6px;
            background: #28abe2;
            border-radius: 50%;
        }

        .kutuBaslik {
            background: #28abe2;
            border-radius: 5px 0 0 5px;
            border: 1px solid #cccccc;
            color: #ffffff;
            font-size: 16px;
            font-weight: bold;
            text-align: center;
            padding: 5px 0;
        }

        .kutuIcerik {
            background: #f2f2f2;
            border: 1px solid #cccccc;
            padding: 5px 0;
            font-size: 16px;
            letter-spacing: 1px;
            text-align: center;
            border-radius: 0 5px 5px 0;
        }

        .tabloBaslik {
            background: #e6297c;
            color: #ffffff;
            border-radius: 5px 5px 0 0;
            padding: 4px 0;
            font-size: 15px;
            font-weight: 600;
            text-align: center;
        }

        .tabloBaslik.sayilar {
            background: #28abe2;
        }


        .dersCol .border .ozelCol:nth-child(odd) .dersRow .col {
            padding: 5px 0;
            text-align: center;
            background: #ffffff;
        }

        .dersCol .border .ozelCol:nth-child(even) .dersRow .col {
            padding: 5px 0;
            text-align: center;
            background: #f9f9f9;
        }

        .dersRow .col::before {
            content: "";
            position: absolute;
        }

        .tabloVeri {
            position: relative;
            font-size: 13px;
        }

        .tabloVeri::before {
            content: "";
            position: absolute;
            right: 0;
            top: -5px;
            height: calc(100% + 10px);
            width: 1px;
            background: #cccccc;
        }

        .tabloVeri::after {
            content: "";
            position: absolute;
            left: 0;
            bottom: -5px;
            height: 1px;
            width: 100%;
            background: #cccccc;
        }

        .border .ozelCol:last-of-type .tabloVeri::after {
            display: none;
        }

        .dersRow .row .col:last-of-type .tabloVeri::before {
            display: none;
        }
        `;
        var openWindow = window.open("", "", "_blank", "location=yes");
        openWindow.document.write('<meta charset="UTF-8">');
        openWindow.document.write('<meta name="viewport" content="width=device-width, initial-scale=1">');
        openWindow.document.write('<meta http-equiv="X-UA-Compatible" content="ie=edge">');
        openWindow.document.write('<title>Sınav Sonuç Sayfası</title>');
        openWindow.document.write('<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/twitter-bootstrap/4.6.0/css/bootstrap.min.css">');
        if (window.outerWidth > 768) {                        
            openWindow.document.write('<style>' + ciktiCSS + '</style>');
            openWindow.document.write(`
            <img src="data:image/png;base64,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" alt="logo" class="img-fluid mt-3"/>
            
            <section class="my-5">
                <div class="container-fluid container-lg">
                    <div class="row">
                        <div class="col-12">
                            <div class="ustAlan">
                                <div class="row align-items-center">
                                    <div class="col-6">
                                        <div class="row justify-content-between align-items-center">
                                            <div class="col-4">
                                                <div class="logoAlani">
                                                <img src="data:image/png;base64,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" alt="" class="img-fluid"/>
                                            </div>
                                            </div>
                                            <div class="col-8">
                                                  <div class="sinavBasligi">
                                                    ${ogrenciSinavBilgileri.baslik}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-6">
                                        <div class="row">
                                            <div class="col-6">
                                                <div class="d-flex justify-content-end">
                                                    <ul class="bilgiBaslik">
                                                        <li>Öğrenci Numarası</li>
                                                        <li>Adı Soyadı</li>
                                                        <li>Okul Adı</li>
                                                        <li>Sınav Tarihi</li>
                                                    </ul>
                                                </div>
                                            </div>
                                            <div class="col-6">
                                                <div class="d-flex justify-content-start">
                                                    <ul class="bilgiIcerik">
                                                        <li>${ogrenciSinavBilgileri.ogrNo}</li>
                                                        <li>${ogrenciSinavBilgileri.adSoyad}</li>
                                                        <li>${ogrenciSinavBilgileri.okulAdi}</li>
                                                        <li>${ogrenciSinavBilgileri.tarih}</li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 my-5">
                            <div class="row justify-content-between">
                                <div class="col-6">
                                    <div class="kutuCerceve">
                                        <div class="kutuBaslik">
                                            TYT Puanı
                                        </div>
                                        <div class="kutuIcerik">
                                            ${veriKontrol(ogrenciSinavBilgileri.tyt_puan)}
                                        </div>
                                    </div>
                                </div>
                                
                               

                                <div class="col-6">
                                    <div class="kutuCerceve">
                                        <div class="kutuBaslik">
                                            Genel Derece
                                        </div>
                                        <div class="kutuIcerik">
                                            ${veriKontrol(ogrenciSinavBilgileri.tyt_derece)}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-12 dersCol">
                            <div class="row">
                                <div class="col">
                                    <div class="tabloBaslik">
                                        Dersler
                                    </div>
                                </div>
                                <div class="col">
                                    <div class="tabloBaslik sayilar">
                                        Doğru
                                    </div>
                                </div>
                                <div class="col">
                                    <div class="tabloBaslik sayilar">
                                        Yanlış
                                    </div>
                                </div>
                                <div class="col">
                                    <div class="tabloBaslik sayilar">
                                        Net
                                    </div>
                                </div>
                            </div>

                            <div class="border">
                                <div class="col-12 ozelCol">
                                    <div class="dersRow">
                                        <div class="row">
                                            <div class="col">
                                                <div class="tabloVeri">
                                                    Türkçe
                                                </div>
                                            </div>
                                            <div class="col">
                                                <div class="tabloVeri">
                                                    ${veriKontrol(ogrenciSinavBilgileri.turkD)}
                                                </div>
                                            </div>
                                            <div class="col">
                                                <div class="tabloVeri">
                                                    ${veriKontrol(ogrenciSinavBilgileri.turkY)}
                                                </div>
                                            </div>
                                            <div class="col">
                                                <div class="tabloVeri">
                                                    ${veriKontrol(ogrenciSinavBilgileri.turkN)}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 ozelCol">
                                    <div class="dersRow">
                                        <div class="row">
                                            <div class="col">
                                                <div class="tabloVeri">
                                                    Matematik
                                                </div>
                                            </div>
                                            <div class="col">
                                                <div class="tabloVeri">
                                                    ${veriKontrol(ogrenciSinavBilgileri.matD)}
                                                </div>
                                            </div>
                                            <div class="col">
                                                <div class="tabloVeri">
                                                    ${veriKontrol(ogrenciSinavBilgileri.matY)}
                                                </div>
                                            </div>
                                            <div class="col">
                                                <div class="tabloVeri">
                                                    ${veriKontrol(ogrenciSinavBilgileri.matN)}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 ozelCol">
                                    <div class="dersRow">
                                        <div class="row">
                                            <div class="col">
                                                <div class="tabloVeri">
                                                    Geometri
                                                </div>
                                            </div>
                                            <div class="col">
                                                <div class="tabloVeri">
                                                    ${veriKontrol(ogrenciSinavBilgileri.geoD)}
                                                </div>
                                            </div>
                                            <div class="col">
                                                <div class="tabloVeri">
                                                    ${veriKontrol(ogrenciSinavBilgileri.geoY)}
                                                </div>
                                            </div>
                                            <div class="col">
                                                <div class="tabloVeri">
                                                    ${veriKontrol(ogrenciSinavBilgileri.geoN)}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 ozelCol">
                                    <div class="dersRow">
                                        <div class="row">
                                            <div class="col">
                                                <div class="tabloVeri">
                                                    Tarih
                                                </div>
                                            </div>
                                            <div class="col">
                                                <div class="tabloVeri">
                                                    ${veriKontrol(ogrenciSinavBilgileri.tarD)}
                                                </div>
                                            </div>
                                            <div class="col">
                                                <div class="tabloVeri">
                                                    ${veriKontrol(ogrenciSinavBilgileri.tarY)}
                                                </div>
                                            </div>
                                            <div class="col">
                                                <div class="tabloVeri">
                                                    ${veriKontrol(ogrenciSinavBilgileri.tarN)}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 ozelCol">
                                    <div class="dersRow">
                                        <div class="row">
                                            <div class="col">
                                                <div class="tabloVeri">
                                                    Coğrafya
                                                </div>
                                            </div>
                                            <div class="col">
                                                <div class="tabloVeri">
                                                    ${veriKontrol(ogrenciSinavBilgileri.cogD)}
                                                </div>
                                            </div>
                                            <div class="col">
                                                <div class="tabloVeri">
                                                    ${veriKontrol(ogrenciSinavBilgileri.cogY)}
                                                </div>
                                            </div>
                                            <div class="col">
                                                <div class="tabloVeri">
                                                    ${veriKontrol(ogrenciSinavBilgileri.cogN)}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 ozelCol">
                                    <div class="dersRow">
                                        <div class="row">
                                            <div class="col">
                                                <div class="tabloVeri">
                                                    Felsefe
                                                </div>
                                            </div>
                                            <div class="col">
                                                <div class="tabloVeri">
                                                    ${veriKontrol(ogrenciSinavBilgileri.felD)}
                                                </div>
                                            </div>
                                            <div class="col">
                                                <div class="tabloVeri">
                                                    ${veriKontrol(ogrenciSinavBilgileri.felY)}
                                                </div>
                                            </div>
                                            <div class="col">
                                                <div class="tabloVeri">
                                                    ${veriKontrol(ogrenciSinavBilgileri.felN)}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 ozelCol">
                                    <div class="dersRow">
                                        <div class="row">
                                            <div class="col">
                                                <div class="tabloVeri">
                                                    Din Kültürü
                                                </div>
                                            </div>
                                            <div class="col">
                                                <div class="tabloVeri">
                                                    ${veriKontrol(ogrenciSinavBilgileri.dinD)}
                                                </div>
                                            </div>
                                            <div class="col">
                                                <div class="tabloVeri">
                                                    ${veriKontrol(ogrenciSinavBilgileri.dinY)}
                                                </div>
                                            </div>
                                            <div class="col">
                                                <div class="tabloVeri">
                                                    ${veriKontrol(ogrenciSinavBilgileri.dinN)}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 ozelCol">
                                    <div class="dersRow">
                                        <div class="row">
                                            <div class="col">
                                                <div class="tabloVeri">
                                                    Fizik
                                                </div>
                                            </div>
                                            <div class="col">
                                                <div class="tabloVeri">
                                                    ${veriKontrol(ogrenciSinavBilgileri.fizD)}
                                                </div>
                                            </div>
                                            <div class="col">
                                                <div class="tabloVeri">
                                                    ${veriKontrol(ogrenciSinavBilgileri.fizY)}
                                                </div>
                                            </div>
                                            <div class="col">
                                                <div class="tabloVeri">
                                                    ${veriKontrol(ogrenciSinavBilgileri.fizN)}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 ozelCol">
                                    <div class="dersRow">
                                        <div class="row">
                                            <div class="col">
                                                <div class="tabloVeri">
                                                    Kimya
                                                </div>
                                            </div>
                                            <div class="col">
                                                <div class="tabloVeri">
                                                    ${veriKontrol(ogrenciSinavBilgileri.kimD)}
                                                </div>
                                            </div>
                                            <div class="col">
                                                <div class="tabloVeri">
                                                    ${veriKontrol(ogrenciSinavBilgileri.kimY)}
                                                </div>
                                            </div>
                                            <div class="col">
                                                <div class="tabloVeri">
                                                    ${veriKontrol(ogrenciSinavBilgileri.kimN)}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 ozelCol">
                                    <div class="dersRow">
                                        <div class="row">
                                            <div class="col">
                                                <div class="tabloVeri">
                                                    Biyoloji
                                                </div>
                                            </div>
                                            <div class="col">
                                                <div class="tabloVeri">
                                                    ${veriKontrol(ogrenciSinavBilgileri.biyD)}
                                                </div>
                                            </div>
                                            <div class="col">
                                                <div class="tabloVeri">
                                                    ${veriKontrol(ogrenciSinavBilgileri.biyY)}
                                                </div>
                                            </div>
                                            <div class="col">
                                                <div class="tabloVeri">
                                                    ${veriKontrol(ogrenciSinavBilgileri.biyN)}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-12 ozelCol">
                                    <div class="dersRow">
                                        <div class="row">
                                            <div class="col">
                                                <div class="tabloVeri">
                                                    Edebiyat
                                                </div>
                                            </div>
                                            <div class="col">
                                                <div class="tabloVeri">
                                                    ${veriKontrol(ogrenciSinavBilgileri.edeD)}
                                                </div>
                                            </div>
                                            <div class="col">
                                                <div class="tabloVeri">
                                                    ${veriKontrol(ogrenciSinavBilgileri.edeY)}
                                                </div>
                                            </div>
                                            <div class="col">
                                                <div class="tabloVeri">
                                                    ${veriKontrol(ogrenciSinavBilgileri.edeN)}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 ozelCol">
                                    <div class="dersRow">
                                        <div class="row">
                                            <div class="col">
                                                <div class="tabloVeri">
                                                    Coğrafya - 1
                                                </div>
                                            </div>
                                            <div class="col">
                                                <div class="tabloVeri">
                                                    ${veriKontrol(ogrenciSinavBilgileri.cog1D)}
                                                </div>
                                            </div>
                                            <div class="col">
                                                <div class="tabloVeri">
                                                    ${veriKontrol(ogrenciSinavBilgileri.cog1Y)}
                                                </div>
                                            </div>
                                            <div class="col">
                                                <div class="tabloVeri">
                                                    ${veriKontrol(ogrenciSinavBilgileri.cog1N)}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 ozelCol">
                                    <div class="dersRow">
                                        <div class="row">
                                            <div class="col">
                                                <div class="tabloVeri">
                                                    Tarih - 2
                                                </div>
                                            </div>
                                            <div class="col">
                                                <div class="tabloVeri">
                                                    ${veriKontrol(ogrenciSinavBilgileri.tar2D)}
                                                </div>
                                            </div>
                                            <div class="col">
                                                <div class="tabloVeri">
                                                    ${veriKontrol(ogrenciSinavBilgileri.tar2Y)}
                                                </div>
                                            </div>
                                            <div class="col">
                                                <div class="tabloVeri">
                                                    ${veriKontrol(ogrenciSinavBilgileri.tar2N)}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 ozelCol">
                                    <div class="dersRow">
                                        <div class="row">
                                            <div class="col">
                                                <div class="tabloVeri">
                                                    Coğrafya - 2
                                                </div>
                                            </div>
                                            <div class="col">
                                                <div class="tabloVeri">
                                                    ${veriKontrol(ogrenciSinavBilgileri.cog2D)}
                                                </div>
                                            </div>
                                            <div class="col">
                                                <div class="tabloVeri">
                                                    ${veriKontrol(ogrenciSinavBilgileri.cog2Y)}
                                                </div>
                                            </div>
                                            <div class="col">
                                                <div class="tabloVeri">
                                                    ${veriKontrol(ogrenciSinavBilgileri.cog2N)}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 ozelCol">
                                    <div class="dersRow">
                                        <div class="row">
                                            <div class="col">
                                                <div class="tabloVeri">
                                                    Din Kültürü - 2
                                                </div>
                                            </div>
                                            <div class="col">
                                                <div class="tabloVeri">
                                                    ${veriKontrol(ogrenciSinavBilgileri.din2D)}
                                                </div>
                                            </div>
                                            <div class="col">
                                                <div class="tabloVeri">
                                                    ${veriKontrol(ogrenciSinavBilgileri.din2Y)}
                                                </div>
                                            </div>
                                            <div class="col">
                                                <div class="tabloVeri">
                                                    ${veriKontrol(ogrenciSinavBilgileri.din2N)}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 ozelCol">
                                    <div class="dersRow">
                                        <div class="row">
                                            <div class="col">
                                                <div class="tabloVeri">
                                                    Matematik - 2
                                                </div>
                                            </div>
                                            <div class="col">
                                                <div class="tabloVeri">
                                                    ${veriKontrol(ogrenciSinavBilgileri.mat2D)}
                                                </div>
                                            </div>
                                            <div class="col">
                                                <div class="tabloVeri">
                                                    ${veriKontrol(ogrenciSinavBilgileri.mat2Y)}
                                                </div>
                                            </div>
                                            <div class="col">
                                                <div class="tabloVeri">
                                                    ${veriKontrol(ogrenciSinavBilgileri.mat2N)}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 ozelCol">
                                    <div class="dersRow">
                                        <div class="row">
                                            <div class="col">
                                                <div class="tabloVeri">
                                                    Fizik - 2
                                                </div>
                                            </div>
                                            <div class="col">
                                                <div class="tabloVeri">
                                                    ${veriKontrol(ogrenciSinavBilgileri.fiz2D)}
                                                </div>
                                            </div>
                                            <div class="col">
                                                <div class="tabloVeri">
                                                    ${veriKontrol(ogrenciSinavBilgileri.fiz2Y)}
                                                </div>
                                            </div>
                                            <div class="col">
                                                <div class="tabloVeri">
                                                    ${veriKontrol(ogrenciSinavBilgileri.fiz2N)}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 ozelCol">
                                    <div class="dersRow">
                                        <div class="row">
                                            <div class="col">
                                                <div class="tabloVeri">
                                                    Kimya - 2
                                                </div>
                                            </div>
                                            <div class="col">
                                                <div class="tabloVeri">
                                                    ${veriKontrol(ogrenciSinavBilgileri.kim2D)}
                                                </div>
                                            </div>
                                            <div class="col">
                                                <div class="tabloVeri">
                                                    ${veriKontrol(ogrenciSinavBilgileri.kim2Y)}
                                                </div>
                                            </div>
                                            <div class="col">
                                                <div class="tabloVeri">
                                                    ${veriKontrol(ogrenciSinavBilgileri.kim2N)}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 ozelCol">
                                    <div class="dersRow">
                                        <div class="row">
                                            <div class="col">
                                                <div class="tabloVeri">
                                                    Biyoloji - 2
                                                </div>
                                            </div>
                                            <div class="col">
                                                <div class="tabloVeri">
                                                    ${veriKontrol(ogrenciSinavBilgileri.biy2D)}
                                                </div>
                                            </div>
                                            <div class="col">
                                                <div class="tabloVeri">
                                                    ${veriKontrol(ogrenciSinavBilgileri.biy2Y)}
                                                </div>
                                            </div>
                                            <div class="col">
                                                <div class="tabloVeri">
                                                    ${veriKontrol(ogrenciSinavBilgileri.biy2N)}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        `);
        } else {
            openWindow.document.write('<style>' + ciktiCSSMobil + '</style>');
            openWindow.document.write(`
            <section class="my-3">
                   
                <div class="container">
                    <div class="row">
                        <div class="col-24">
                            <img src="data:image/png;base64,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" alt="logo" class="img-fluid"/>
                        </div>
                        <div class="col-12" style="padding-top:20px">
                            <div class="ustAlan">
                                <div class="row align-items-center">
                                    <div class="col-12 mb-3 pembebg">
                                        <div class="sinavBasligi">
                                            ${ogrenciSinavBilgileri.baslik}
                                        </div>
                                    </div>
                                    <div class="col-12">
                                        <div class="row">
                                            <div class="col-6">
                                                <ul class="bilgiBaslik">
                                                    <li>Öğrenci Numarası</li>
                                                    <li>Adı Soyadı</li>
                                                    <li>Okul Adı</li>
                                                    <li>Sınav Tarihi</li>
                                                </ul>
                                            </div>
                                            <div class="col-6">
                                                <ul class="bilgiIcerik">
                                                    <li>${ogrenciSinavBilgileri.ogrNo}</li>
                                                    <li>${ogrenciSinavBilgileri.adSoyad}</li>
                                                    <li>${ogrenciSinavBilgileri.okulAdi}</li>
                                                    <li>${ogrenciSinavBilgileri.tarih}</li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 my-3">
                            <div class="row">
                                <div class="col-12 my-1">
                                    <div class="row no-gutters">
                                        <div class="col-6">
                                            <div class="kutuBaslik">
                                                TYT Puanı
                                            </div>
                                        </div>
                                        <div class="col-6">
                                            <div class="kutuIcerik">
                                                ${veriKontrol(ogrenciSinavBilgileri.tyt_puan)}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 my-1">
                                    <div class="row no-gutters">
                                        <div class="col-6">
                                            <div class="kutuBaslik">
                                                Genel Derece
                                            </div>
                                        </div>
                                        <div class="col-6">
                                            <div class="kutuIcerik">
                                                ${veriKontrol(ogrenciSinavBilgileri.tyt_derece)}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 dersCol">
                            <div class="row">
                                <div class="col">
                                    <div class="tabloBaslik">
                                        Dersler
                                    </div>
                                </div>
                                <div class="col">
                                    <div class="tabloBaslik sayilar">
                                        Doğru
                                    </div>
                                </div>
                                <div class="col">
                                    <div class="tabloBaslik sayilar">
                                        Yanlış
                                    </div>
                                </div>
                                <div class="col">
                                    <div class="tabloBaslik sayilar">
                                        Net
                                    </div>
                                </div>
                            </div>
                            <div class="border">
                                <div class="col-12 ozelCol">
                                    <div class="dersRow">
                                        <div class="row">
                                            <div class="col">
                                                <div class="tabloVeri">
                                                    Türkçe
                                                </div>
                                            </div>
                                            <div class="col">
                                                <div class="tabloVeri">
                                                    ${veriKontrol(ogrenciSinavBilgileri.turkD)}
                                                </div>
                                            </div>
                                            <div class="col">
                                                <div class="tabloVeri">
                                                    ${veriKontrol(ogrenciSinavBilgileri.turkY)}
                                                </div>
                                            </div>
                                            <div class="col">
                                                <div class="tabloVeri">
                                                    ${veriKontrol(ogrenciSinavBilgileri.turkN)}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 ozelCol">
                                    <div class="dersRow">
                                        <div class="row">
                                            <div class="col">
                                                <div class="tabloVeri">
                                                    Matematik
                                                </div>
                                            </div>
                                            <div class="col">
                                                <div class="tabloVeri">
                                                    ${veriKontrol(ogrenciSinavBilgileri.matD)}
                                                </div>
                                            </div>
                                            <div class="col">
                                                <div class="tabloVeri">
                                                    ${veriKontrol(ogrenciSinavBilgileri.matY)}
                                                </div>
                                            </div>
                                            <div class="col">
                                                <div class="tabloVeri">
                                                    ${veriKontrol(ogrenciSinavBilgileri.matN)}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 ozelCol">
                                    <div class="dersRow">
                                        <div class="row">
                                            <div class="col">
                                                <div class="tabloVeri">
                                                    Geometri
                                                </div>
                                            </div>
                                            <div class="col">
                                                <div class="tabloVeri">
                                                    ${veriKontrol(ogrenciSinavBilgileri.geoD)}
                                                </div>
                                            </div>
                                            <div class="col">
                                                <div class="tabloVeri">
                                                    ${veriKontrol(ogrenciSinavBilgileri.geoY)}
                                                </div>
                                            </div>
                                            <div class="col">
                                                <div class="tabloVeri">
                                                    ${veriKontrol(ogrenciSinavBilgileri.geoN)}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 ozelCol">
                                    <div class="dersRow">
                                        <div class="row">
                                            <div class="col">
                                                <div class="tabloVeri">
                                                    Tarih
                                                </div>
                                            </div>
                                            <div class="col">
                                                <div class="tabloVeri">
                                                    ${veriKontrol(ogrenciSinavBilgileri.tarD)}
                                                </div>
                                            </div>
                                            <div class="col">
                                                <div class="tabloVeri">
                                                    ${veriKontrol(ogrenciSinavBilgileri.tarY)}
                                                </div>
                                            </div>
                                            <div class="col">
                                                <div class="tabloVeri">
                                                    ${veriKontrol(ogrenciSinavBilgileri.tarN)}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 ozelCol">
                                    <div class="dersRow">
                                        <div class="row">
                                            <div class="col">
                                                <div class="tabloVeri">
                                                    Coğrafya
                                                </div>
                                            </div>
                                            <div class="col">
                                                <div class="tabloVeri">
                                                    ${veriKontrol(ogrenciSinavBilgileri.cogD)}
                                                </div>
                                            </div>
                                            <div class="col">
                                                <div class="tabloVeri">
                                                    ${veriKontrol(ogrenciSinavBilgileri.cogY)}
                                                </div>
                                            </div>
                                            <div class="col">
                                                <div class="tabloVeri">
                                                    ${veriKontrol(ogrenciSinavBilgileri.cogN)}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 ozelCol">
                                    <div class="dersRow">
                                        <div class="row">
                                            <div class="col">
                                                <div class="tabloVeri">
                                                    Felsefe
                                                </div>
                                            </div>
                                            <div class="col">
                                                <div class="tabloVeri">
                                                    ${veriKontrol(ogrenciSinavBilgileri.felD)}
                                                </div>
                                            </div>
                                            <div class="col">
                                                <div class="tabloVeri">
                                                    ${veriKontrol(ogrenciSinavBilgileri.felY)}
                                                </div>
                                            </div>
                                            <div class="col">
                                                <div class="tabloVeri">
                                                    ${veriKontrol(ogrenciSinavBilgileri.felN)}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 ozelCol">
                                    <div class="dersRow">
                                        <div class="row">
                                            <div class="col">
                                                <div class="tabloVeri">
                                                    Din Kültürü
                                                </div>
                                            </div>
                                            <div class="col">
                                                <div class="tabloVeri">
                                                    ${veriKontrol(ogrenciSinavBilgileri.dinD)}
                                                </div>
                                            </div>
                                            <div class="col">
                                                <div class="tabloVeri">
                                                    ${veriKontrol(ogrenciSinavBilgileri.dinY)}
                                                </div>
                                            </div>
                                            <div class="col">
                                                <div class="tabloVeri">
                                                    ${veriKontrol(ogrenciSinavBilgileri.dinN)}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 ozelCol">
                                    <div class="dersRow">
                                        <div class="row">
                                            <div class="col">
                                                <div class="tabloVeri">
                                                    Fizik
                                                </div>
                                            </div>
                                            <div class="col">
                                                <div class="tabloVeri">
                                                    ${veriKontrol(ogrenciSinavBilgileri.fizD)}
                                                </div>
                                            </div>
                                            <div class="col">
                                                <div class="tabloVeri">
                                                    ${veriKontrol(ogrenciSinavBilgileri.fizY)}
                                                </div>
                                            </div>
                                            <div class="col">
                                                <div class="tabloVeri">
                                                    ${veriKontrol(ogrenciSinavBilgileri.fizN)}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 ozelCol">
                                    <div class="dersRow">
                                        <div class="row">
                                            <div class="col">
                                                <div class="tabloVeri">
                                                    Kimya
                                                </div>
                                            </div>
                                            <div class="col">
                                                <div class="tabloVeri">
                                                    ${veriKontrol(ogrenciSinavBilgileri.kimD)}
                                                </div>
                                            </div>
                                            <div class="col">
                                                <div class="tabloVeri">
                                                    ${veriKontrol(ogrenciSinavBilgileri.kimY)}
                                                </div>
                                            </div>
                                            <div class="col">
                                                <div class="tabloVeri">
                                                    ${veriKontrol(ogrenciSinavBilgileri.kimN)}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 ozelCol">
                                    <div class="dersRow">
                                        <div class="row">
                                            <div class="col">
                                                <div class="tabloVeri">
                                                    Biyoloji
                                                </div>
                                            </div>
                                            <div class="col">
                                                <div class="tabloVeri">
                                                    ${veriKontrol(ogrenciSinavBilgileri.biyD)}
                                                </div>
                                            </div>
                                            <div class="col">
                                                <div class="tabloVeri">
                                                    ${veriKontrol(ogrenciSinavBilgileri.biyY)}
                                                </div>
                                            </div>
                                            <div class="col">
                                                <div class="tabloVeri">
                                                    ${veriKontrol(ogrenciSinavBilgileri.biyN)}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-12 ozelCol">
                                    <div class="dersRow">
                                        <div class="row">
                                            <div class="col">
                                                <div class="tabloVeri">
                                                    Edebiyat
                                                </div>
                                            </div>
                                            <div class="col">
                                                <div class="tabloVeri">
                                                    ${veriKontrol(ogrenciSinavBilgileri.edeD)}
                                                </div>
                                            </div>
                                            <div class="col">
                                                <div class="tabloVeri">
                                                    ${veriKontrol(ogrenciSinavBilgileri.edeY)}
                                                </div>
                                            </div>
                                            <div class="col">
                                                <div class="tabloVeri">
                                                    ${veriKontrol(ogrenciSinavBilgileri.edeN)}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 ozelCol">
                                    <div class="dersRow">
                                        <div class="row">
                                            <div class="col">
                                                <div class="tabloVeri">
                                                    Coğrafya - 1
                                                </div>
                                            </div>
                                            <div class="col">
                                                <div class="tabloVeri">
                                                    ${veriKontrol(ogrenciSinavBilgileri.cog1D)}
                                                </div>
                                            </div>
                                            <div class="col">
                                                <div class="tabloVeri">
                                                    ${veriKontrol(ogrenciSinavBilgileri.cog1Y)}
                                                </div>
                                            </div>
                                            <div class="col">
                                                <div class="tabloVeri">
                                                    ${veriKontrol(ogrenciSinavBilgileri.cog1N)}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 ozelCol">
                                    <div class="dersRow">
                                        <div class="row">
                                            <div class="col">
                                                <div class="tabloVeri">
                                                    Tarih - 2
                                                </div>
                                            </div>
                                            <div class="col">
                                                <div class="tabloVeri">
                                                    ${veriKontrol(ogrenciSinavBilgileri.tar2D)}
                                                </div>
                                            </div>
                                            <div class="col">
                                                <div class="tabloVeri">
                                                    ${veriKontrol(ogrenciSinavBilgileri.tar2Y)}
                                                </div>
                                            </div>
                                            <div class="col">
                                                <div class="tabloVeri">
                                                    ${veriKontrol(ogrenciSinavBilgileri.tar2N)}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 ozelCol">
                                    <div class="dersRow">
                                        <div class="row">
                                            <div class="col">
                                                <div class="tabloVeri">
                                                    Coğrafya - 2
                                                </div>
                                            </div>
                                            <div class="col">
                                                <div class="tabloVeri">
                                                    ${veriKontrol(ogrenciSinavBilgileri.cog2D)}
                                                </div>
                                            </div>
                                            <div class="col">
                                                <div class="tabloVeri">
                                                    ${veriKontrol(ogrenciSinavBilgileri.cog2Y)}
                                                </div>
                                            </div>
                                            <div class="col">
                                                <div class="tabloVeri">
                                                    ${veriKontrol(ogrenciSinavBilgileri.cog2N)}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 ozelCol">
                                    <div class="dersRow">
                                        <div class="row">
                                            <div class="col">
                                                <div class="tabloVeri">
                                                    Din Kültürü - 2
                                                </div>
                                            </div>
                                            <div class="col">
                                                <div class="tabloVeri">
                                                    ${veriKontrol(ogrenciSinavBilgileri.din2D)}
                                                </div>
                                            </div>
                                            <div class="col">
                                                <div class="tabloVeri">
                                                    ${veriKontrol(ogrenciSinavBilgileri.din2Y)}
                                                </div>
                                            </div>
                                            <div class="col">
                                                <div class="tabloVeri">
                                                    ${veriKontrol(ogrenciSinavBilgileri.din2N)}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 ozelCol">
                                    <div class="dersRow">
                                        <div class="row">
                                            <div class="col">
                                                <div class="tabloVeri">
                                                    Matematik - 2
                                                </div>
                                            </div>
                                            <div class="col">
                                                <div class="tabloVeri">
                                                    ${veriKontrol(ogrenciSinavBilgileri.mat2D)}
                                                </div>
                                            </div>
                                            <div class="col">
                                                <div class="tabloVeri">
                                                    ${veriKontrol(ogrenciSinavBilgileri.mat2Y)}
                                                </div>
                                            </div>
                                            <div class="col">
                                                <div class="tabloVeri">
                                                    ${veriKontrol(ogrenciSinavBilgileri.mat2N)}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 ozelCol">
                                    <div class="dersRow">
                                        <div class="row">
                                            <div class="col">
                                                <div class="tabloVeri">
                                                    Fizik - 2
                                                </div>
                                            </div>
                                            <div class="col">
                                                <div class="tabloVeri">
                                                    ${veriKontrol(ogrenciSinavBilgileri.fiz2D)}
                                                </div>
                                            </div>
                                            <div class="col">
                                                <div class="tabloVeri">
                                                    ${veriKontrol(ogrenciSinavBilgileri.fiz2Y)}
                                                </div>
                                            </div>
                                            <div class="col">
                                                <div class="tabloVeri">
                                                    ${veriKontrol(ogrenciSinavBilgileri.fiz2N)}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 ozelCol">
                                    <div class="dersRow">
                                        <div class="row">
                                            <div class="col">
                                                <div class="tabloVeri">
                                                    Kimya - 2
                                                </div>
                                            </div>
                                            <div class="col">
                                                <div class="tabloVeri">
                                                    ${veriKontrol(ogrenciSinavBilgileri.kim2D)}
                                                </div>
                                            </div>
                                            <div class="col">
                                                <div class="tabloVeri">
                                                    ${veriKontrol(ogrenciSinavBilgileri.kim2Y)}
                                                </div>
                                            </div>
                                            <div class="col">
                                                <div class="tabloVeri">
                                                    ${veriKontrol(ogrenciSinavBilgileri.kim2N)}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 ozelCol">
                                    <div class="dersRow">
                                        <div class="row">
                                            <div class="col">
                                                <div class="tabloVeri">
                                                    Biyoloji - 2
                                                </div>
                                            </div>
                                            <div class="col">
                                                <div class="tabloVeri">
                                                    ${veriKontrol(ogrenciSinavBilgileri.biy2D)}
                                                </div>
                                            </div>
                                            <div class="col">
                                                <div class="tabloVeri">
                                                    ${veriKontrol(ogrenciSinavBilgileri.biy2Y)}
                                                </div>
                                            </div>
                                            <div class="col">
                                                <div class="tabloVeri">
                                                    ${veriKontrol(ogrenciSinavBilgileri.biy2N)}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        `);
        }
        openWindow.focus();       
    }
</script>

<style scoped>

</style>
